import { produce } from 'immer';
import * as api from '../../lib/api';
import { normalizeStatus } from '../../lib/statuses';
import { ScopedType } from './scoped-type';

const Type = ScopedType('NRX');

const LOAD_NRX_FOR_GROWER_BEGIN = Type('LOAD_NRX_FOR_GROWER_BEGIN');
const LOAD_NRX_FOR_GROWER_END = Type('LOAD_NRX_FOR_GROWER_END');
const LOAD_NRX_FOR_GROWER_ERROR = Type('LOAD_NRX_FOR_GROWER_ERROR');

const SLICE = 'nrx';

export const selectors = {
  isLoading: (state) => state[SLICE].isLoading,
  fields: (state) => addSortColumns(state[SLICE].fields),
  error: (state) => state[SLICE].error,
};

export const actions = {
  loadNrxForGrower,
};

const reducerHandlers = {
  [LOAD_NRX_FOR_GROWER_BEGIN]: reduceLoadNrxForGrowerBegin,
  [LOAD_NRX_FOR_GROWER_END]: reduceLoadNrxForGrowerEnd,
  [LOAD_NRX_FOR_GROWER_ERROR]: reduceLoadNrxForGrowerError,
};

export const reducers = {
  [SLICE]: (state = {}, { type, payload } = {}) => {
    if (!reducerHandlers[type]) return state;
    return produce(state, (draft) => reducerHandlers[type](draft, payload));
  },
};

function loadNrxForGrowerBegin(growerId) {
  return {
    type: LOAD_NRX_FOR_GROWER_BEGIN,
    growerId,
  };
}

function loadNrxForGrowerEnd(data) {
  return {
    type: LOAD_NRX_FOR_GROWER_END,
    payload: data,
  };
}

function loadNrxForGrowerError(error) {
  return {
    type: LOAD_NRX_FOR_GROWER_ERROR,
    error,
  };
}

function addSortColumns(data) {
  if (!data) return [];
  return data.map((item) => {
    const status = normalizeStatus(item.rxStatus, item.hasNrx);
    const cornAfterCorn = () => {
      if (status !== 'Complete' || item.cornAfterCorn === null) return '3';
      return item.cornAfterCorn ? '1' : '2';
    };
    return {
      ...item,
      rxStatusSortValue: status,
      cornAfterCornSortValue: cornAfterCorn(),
      createdDateSortValue: status === 'Complete' ? item.createdDate : null,
      adjustSortValue: status,
    };
  });
}

function loadNrxForGrower(growerId) {
  return (dispatch) => {
    dispatch(loadNrxForGrowerBegin(growerId));

    return api.getNrxForGrower(growerId).then(
      (data) => dispatch(loadNrxForGrowerEnd(data)),
      (error) => dispatch(loadNrxForGrowerError(error)),
    );
  };
}

function reduceLoadNrxForGrowerBegin(state) {
  state.isLoading = true;
  state.error = null;
  state.fields = [];
}

function reduceLoadNrxForGrowerEnd(state, payload) {
  state.fields = payload;
  state.isLoading = false;
  state.error = null;
}

function reduceLoadNrxForGrowerError(state, payload) {
  state.fields = [];
  state.error = payload;
  state.isLoading = false;
}
